import styles from './HeroBannerSkeleton.module.scss';

/**
 * Loading skeleton for the HeroBanner component.
 * Displayed while banner data is being fetched.
 */
const HeroBannerSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.skeleton} />
    </div>
  );
};

export default HeroBannerSkeleton;
